<template>
  <div class="VerifyRef">
    <div class="Con">
      <img src="../../../../static/img/logo_cover.png" width="80%">
      <div>
        <label class="AppText">您的申请已被拒绝</label>
        <div class="AppDesc">
          <label>{{ OnMod.AppDesc }}</label>
        </div>
        <div class="AppBtn">
          <mu-flex justify-content="center" align-items="center">
            <mu-button full-width color="primary" @click="ReApp">重新申请</mu-button>
          </mu-flex>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerifyRef',
  props: {
    OnMod: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    ReApp: function() {
      this.$emit('ReApp')
    }
  }
}
</script>

<style scoped>
.VerifyRef{
  position: absolute;
  left: 0;
  top: calc(50% - 56px);
  visibility: visible;
  opacity: 1;
  bottom: 0;
  right: 0;
  text-align: center;
}
.Con{
  object-fit:contain;
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
  transform:translateY(-50%);
  -ms-transform:translateY(-50%);
  -moz-transform:translateY(-50%);
  -webkit-transform:translateY(-50%);
  -o-transform:translateY(-50%);
}
.AppText {
  color: #30328a;
  line-height: 40px;
  font-size: 18px;
}
.AppDesc{
  margin: 20px;
  color: #c90000;
  line-height: 25px;
  font-size: 14px;
}

.AppBtn{
  margin: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/OnLineBook/components/VerifyRef.vue